import { HttpLink, from } from "@apollo/client";
import { NotificationManager } from "react-notifications";

const link = from([
  new HttpLink({
    uri: process.env.API_REST_FILE,
  }),
]);

const urlApi = from([
  new HttpLink({
    uri: process.env.API_REST_MULTIPLE_FILES,
  }),
]);

export function getFile(fileName, admin = false) {
  return fetch(`${link.options.uri}/get?fileName=${fileName}&admin=${admin}`, {
    headers: {
      "Content-Type": "application/json; charset=utf8",
    },
  }).then((response) => {
    if (response.status === 200) {
      return response.blob();
    }
  });
}

export function uploadFile(fileInput, folderName) {
  const formdata = new FormData();

  fileInput.forEach((element) => {
    formdata.append("files", element, element.name);
    let consulting = element.name.indexOf("/");
    if (consulting === -1) {
      formdata.append("route", folderName);
    }
  });

  let requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow",
    headers: {},
  };

  return fetch(`${link.options.uri}/upload`, requestOptions)
    .then((response) => response.text())
    .catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
}

export function uploadPDFAndImgFiles(fileInput, folderName) {
  const formdata = new FormData();

  formdata.append("files", fileInput, fileInput.name);
  let consulting = fileInput.name.indexOf("/");
  if (consulting === -1) {
    formdata.append("route", folderName);
  }

  let requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow",
    headers: {},
  };

  return fetch(`${urlApi.options.uri}/UploadFiles`, requestOptions)
    .then((response) => response.text())
    .catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
}
